import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './SettingsModal.css';

const SettingsModal = ({ isOpen, onClose, children, title = 'Настройки', size = 'md' }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClass =
    size === 'lg' ? ' settings-modal--lg' : size === 'sm' ? ' settings-modal--sm' : '';

  const modalContent = (
    <div className="settings-modal-overlay" onClick={onClose}>
      <div className={`settings-modal${sizeClass}`} onClick={(e) => e.stopPropagation()}>
        <div className="settings-modal-header">
          <h2>{title}</h2>
          <button type="button" className="settings-modal-close" onClick={onClose} aria-label="Закрыть">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div className="settings-modal-content">
          {children}
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default SettingsModal;


